export enum UserTypeEnum {
  Undefined = 'undefined',
  Admin = 'admin',
  SuperAdmin = 'super_admin',
  SecurityOfficer = 'security_officer',
  WebGuest = 'web_guest',
}
